const wizardComponentsHelper = require('routes/contractsView/utilities/wizardComponenstHelper');
const inputs = require('routes/contractsView/fioc/inputs.js');

function buildWithoutActivity(prefix, authorized = false) {
    const inputsFioc = wizardComponentsHelper.replacePrefix(inputs.fioc, prefix);
    let grid = [[inputsFioc.your_job]];
    if (!authorized) {
        grid = [
            ...grid
        ];
    }

    return {
        id_component: 'condition-show',
        id: 'show',
        conditionType: 'single',
        conditionId1: prefix + 'fioc_ocupation',
        conditionValue1: 4,
        item: {
            id_component: 'fioc',
            id: prefix + 'fioc_pensioner',
            exclude: [],
            grid
        }
    }
}

module.exports = buildWithoutActivity;